import React, { createContext, useContext, useState, useEffect } from 'react';

// Supported languages
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'gu', name: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' }
];

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Try to get language from localStorage or browser
  const getInitialLanguage = () => {
    const saved = localStorage.getItem('easystay_language');
    if (saved) return saved;
    
    // Auto-detect from browser
    const browserLang = navigator.language.split('-')[0];
    const supported = SUPPORTED_LANGUAGES.find(l => l.code === browserLang);
    return supported ? browserLang : 'en';
  };

  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = (code) => {
    setLanguageState(code);
    localStorage.setItem('easystay_language', code);
  };

  const t = (key) => {
    // Translation function will look up the key in translations
    try {
      const translations = require(`../translations/${language}.json`);
      return translations[key] || key;
    } catch (e) {
      return key;
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages: SUPPORTED_LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
